<div
  class="custom-modal-component flex-column"
  [ngClass]="{
    'd-xl-none custom-modal-component__profile': isProfileComponent
  }"
>
  <header
    *ngIf="isProfileComponent"
    class="custom-modal-component__header d-flex justify-content-between align-items-center px-3 mb-3 d-none"
  >
    <a [routerLink]="'/'">
      <img src="/assets/images/logo.svg" alt="logo" />
    </a>
    <a (click)="closeModal()">
      <img src="/assets/images/close.svg" alt="x" />
    </a>
  </header>
  <div class="modal-classes">
    <div modal-host></div>
  </div>
</div>
